var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "button button--white-hover-grad pulse",
      attrs: { id: "login-form-submit", type: "submit" }
    },
    [
      !_vm.pending ? _c("span", [_vm._t("default")], 2) : _vm._e(),
      _vm._v(" "),
      _vm.pending
        ? _c(
            "span",
            [
              _c("br"),
              _vm._v(" "),
              _c("Loader", {
                attrs: { "custom-class": "size-sm button--loader" }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }